import { render, staticRenderFns } from "./InterviewerRadioForm.vue?vue&type=template&id=2bb23982"
import script from "./InterviewerRadioForm.vue?vue&type=script&lang=js"
export * from "./InterviewerRadioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports